// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__XGAGO","thumbnails":"Slider_thumbnails__wCySj","vertical":"Slider_vertical__7Jcmk","horizontal":"Slider_horizontal__6rUDO"};